import React from "react";
import './Button.scss';

type ButtonProps = {
  label?: string;
  action: any;
  busy?: boolean;
};
export const Button = ({ label, action, busy }: ButtonProps) => {
  return (
    <button className={"c-hex-button"} onClick={() => action()}>
      <p className="c-hex-button-text">{label}</p>
      {busy && <div className="spinner"></div>}
    </button>
  );
};
